import Row from "components/general.compoenents/row.component/row.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-regular-svg-icons";
import React, { useEffect } from "react";
import GymoLogo from "components/general.compoenents/gymo.logo.component/gymo.logo.component";
import "./mobile.header.comonent.scss";
import { useLocation } from "react-router";

const MobileHeader = (): JSX.Element => {
  if (window.innerWidth >= 471) {
    return <></>;
  }

  const navigation = document.getElementById("navigation-bar");
  const location = useLocation();

  useEffect(() => {
    if (navigation == null) {
      return;
    }

    navigation.style.display = "none";
  }, [location]);

  const showMobileNavigation = (): void => {
    if (navigation == null) {
      return;
    }

    navigation.style.display = "flex";
  };

  if (
    location.pathname === "/" ||
    location.pathname === "/sign-in" ||
    location.pathname === "/sign-up"
  ) {
    return <></>;
  }

  return (
    <Row
      className="mobile-header-container"
      justifyContent="space-between"
      alignItems="center"
    >
      <GymoLogo size={30} />
      <FontAwesomeIcon
        className="mobile-header-container-burger"
        onClick={showMobileNavigation}
        icon={faBars}
      />
    </Row>
  );
};

export default MobileHeader;
